import type { ReactNode } from 'react';
import styles from './CdPublicTemplate.module.scss';

export interface CdPublicTemplateProps {
  /** Usually a `PublicHeader`. */
  header: ReactNode;
  /** Usually a `SiteFooter`. */
  footer: ReactNode;
  children: ReactNode;
  skipLinkLabel?: string;
}

/** Logged-out layout: header, full-width content sections, navy footer. */
export const CdPublicTemplate = ({
  header,
  footer,
  children,
  skipLinkLabel = 'Skip to main content',
}: CdPublicTemplateProps) => {
  return (
    <div className={styles.page}>
      <a href="#main-content" className={styles.skipLink}>
        {skipLinkLabel}
      </a>
      {header}
      <main id="main-content" className={styles.main} tabIndex={-1}>
        {children}
      </main>
      {footer}
    </div>
  );
};
